export default {
	"Group.remainder": "remainder",
	"Group.TheyAreInAGroupAndCanBeDirectlyInvolved": "They are in a group and can be directly involved",
	"Group.NotBad": "Not bad",
	"Group.PeopleInGroups": "People in groups",
	"Group.GoOnATour": "Go on a tour"
}